export const required = (v: unknown): boolean | string =>
  (v !== null && v !== undefined && v !== '') || 'Requerido.'

export const validEmail = (v: unknown): boolean | string => {
  if (v === null || v === undefined || v === '') return true
  if (typeof v !== 'string') return 'E-mail debe ser válido'
  return /.+@.+\..+/.test(v) || 'E-mail debe ser válido'
}

export const minDigits = (
  v: string | number | null | undefined,
  min = 1
): boolean | string => {
  if (v === null || v === undefined || v === '') return true
  const length = typeof v === 'number' ? String(v).length : typeof v === 'string' ? v.length : 0
  return length >= min || `Debe poseer al menos ${min} caracteres`
}

export const maxDigits = (
  v: string | number | null | undefined,
  max: number
): boolean | string => {
  if (v === null || v === undefined || v === '') return true
  const length = typeof v === 'number' ? String(v).length : typeof v === 'string' ? v.length : 0
  return length <= max || `Debe poseer menos de ${max} caracteres`
}

export const validRange = (
  v: string | number | null | undefined,
  { type = 'string', min = 1, max = 250 }: { type?: 'string' | 'number'; min?: number; max?: number } = {}
): boolean | string => {
  if (type === 'string') {
    if (typeof v !== 'string') return true
    if (v.length < min) return `Debe poseer al menos ${min} caracteres`
    if (v.length > max) return `Debe poseer menos de ${max} caracteres`
  } else if (type === 'number') {
    if (typeof v !== 'number') return true
    if (v < min) return `Debe ser mayor o igual a ${min}`
    if (v > max) return `Debe ser menor o igual a ${max}`
  }
  return true
}

export const validLength = (
  v: string | { length: number } | null | undefined,
  length: number
): boolean | string => (v ? (v as any).length === length : true) || `Debe poseer ${length} caracteres`

export const validDate = (v: Date | string | number | null | undefined): boolean | string =>
  (v === null || v === undefined || v === '' || !isNaN(new Date(v).getTime())) || 'Debe ser una fecha válida'

// Define the options type for validDateRange
type DateLike = Date | string | number;
type DateRangeOptions = {
  min?: DateLike;
  max?: DateLike;
};

// Update the function signature to accept typed options
export const validDateRange = (v: DateLike, options: DateRangeOptions = {}) => {
  const { min, max } = options;
  if (!v) return true
  const date = new Date(v)
  if (min && date < new Date(min)) return `Debe ser mayor o igual a ${min}`
  if (max && date > new Date(max)) return `Debe ser menor o igual a ${max}`
  return true
}
